
import { Component, Vue } from "vue-property-decorator";
import { GaodeService, OrganizationService, PackageService, OrderService, FamilyService } from "src/services";

@Component
export default class GoodsDetail extends Vue
{

    /**
     * loading次数
     * @private
     * @returns string
     */
     private get id(): string
    {
        return this.$route.query.id as string
    }


    /**
     * 立即使用
     * @private
     * @returns 
     */
     protected onUse() {
        const id = this.id
        this.$router.push({name: 'rights-detail',query:{id}})
     }
     

}
